import { z } from 'zod';

/** GET /pos/business-drivers: the catalog projection, not a commissioning DTO. */
export const posBusinessDriverListItemSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  name: z.string(),
  slug: z.string().nullable(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  sort_order: z.number().int().nullable(),
  is_active: z.boolean().nullable(),
  created_at: z.string().datetime({ offset: true }).nullable(),
  updated_at: z.string().datetime({ offset: true }).nullable(),
  retail_brand_id: z.string().uuid().nullable(),
  store_id: z.string().uuid().nullable(),
  channel_id: z.string().uuid().nullable(),
  managed_by_org_id: z.string().uuid().nullable(),
  is_locked: z.boolean(),
  retail_brand_name: z.string().nullable(),
  channel_name: z.string().nullable(),
  store_name: z.string().nullable(),
  linked_categories_count: z.number().int().nonnegative(),
});
export const posBusinessDriverListSchema = z.array(posBusinessDriverListItemSchema);
export type PosBusinessDriverListItem = z.infer<typeof posBusinessDriverListItemSchema>;
